


export const all_routes = {
  dashboard: "/dashboard",
  products: "/products",
  productsync: "/productsync",
  inventory: "/inventory",
  inventorysync: "/inventorysync",
  sales: "/sales",
  salessync: "/salessync",
  salesdailyreport: "/salesdailyreport",
  users: "/users",
  rolespermission: "/roles-permissions",
  permissions: "/permissions",
  permissiontemplate: "/permissiontemplate",
  InvoiceDetail: "/invoice-detail",
  InvoiceDetailID: "/invoice-detail/:id",
  // ==================== Default Sidebar Routes ====================//
  defaultpermissions: "/defaultpermissions",
  productlist: "/product-list",
  addproduct: "/add-product",
  salesdashboard: "/sales-dashboard",
  brandlist: "/brand-list",
  units: "/units",
  variantyattributes: "/variant-attributes",
  warranty: "/warranty",
  barcode: "/barcode",
  alerts: "/ui-alerts",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  borders: "/ui-borders",
  buttons: "ui-buttons",
  buttonsgroup: "/ui-buttons-group",
  breadcrumb: "/ui-breadcrumb",
  cards: "/ui-cards",
  dropdowns: "/ui-dropdowns",
  colors: "/ui-colors",
  carousel: "/ui-carousel",
  navtabs: "/ui-nav-tabs",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  typography: "/ui-typography",
  tooltip: "/ui-tooltips",
  draganddrop: "/ui-drag-drop",
  departmentgrid: "/department-grid",
  departmentlist: "/department-list",
  designation: "/designation",
  shift: "/shift",
  attendanceemployee: "/attendance-employee",
  clipboard: "/ui-clipboard",
  popover: "/ui-popovers",
  tablebasic: "/tables-basic",
  datatable: "/data-tables",
  basicinput: "/form-basic-inputs",
  checkboxradio: "/form-checkbox-radios",
  inputgroup: "/form-input-groups",
  gridgutters: "/form-grid-gutters",
  formselect: "/form-select",
  fileupload: "/form-fileupload",
  formmask: "/form-mask",
  formhorizontal: "/form-horizontal",
  formvertical: "/form-vertical",
  floatinglabel: "/form-floating-labels",
  formvalidation: "/form-validation",
  select2: "/form-select2",

  toasts: "/ui-toasts",
  video: "/ui-video",
  sweetalerts: "/ui-sweetalerts",
  spinner: "/ui-spinner",
  progress: "/ui-progress",
  placeholder: "/ui-placeholders",
  rating: "/ui-rating",
  texteditor: "/ui-text-editor",
  counter: "/ui-counter",
  scrollbar: "/ui-scrollbar",
  stickynote: "/ui-stickynote",
  timeline: "/ui-timeline",
  apexchart: "/chart-apex",
  chartjs: "/chart-js",
  rangeslider: "/ui-rangeslider",
  fontawesome: "/icon-fontawesome",
  feathericon: "/icon-feather",
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  ribbon: "/ui-ribbon",

  chat: "/chat",
  videocall: "/video-call",
  audiocall: "/audio-call",
  email: "/email",
  callhistory: "/call-history",
  todo: "/todo",
  wizard: "/form-wizard",
  expiredproduct: "/expired-products",
  lowstock: "/low-stocks",
  categorylist: "/category-list",
  subcategories: "/sub-categories",
  productdetails: "/product-details",
  editproduct: "/edit-product",
  expenselist: "/expense-list",
  expensecategory: "/expense-category",
  calendar: "/calendar",
  variantattributes: "/variant-attributes",
  qrcode: "/qrcode",
  purchaselist: "/purchase-list",
  purchaseorderreport: "/purchase-order-report",
  purchasereturn: "/purchase-returns",
  appearance: "/appearance",
  socialauthendication: "/social-authentication",
  languagesettings: "/language-settings",
  invoicesettings: "/invoice-settings",
  printersettings: "/printer-settings",
  possettings: "/pos-settings",
  customfields: "/custom-fields",
  emailsettings: "/email-settings",
  smssettings: "/sms-gateway",
  otpsettings: "/otp-settings",
  gdbrsettings: "/gdpr-settings",
  paymentgateway: "/payment-gateway-settings",
  banksettingslist: "/bank-settings-list",
  banksettingsgrid: "/bank-settings-grid",
  taxrates: "/tax-rates",
  currencysettings: "/currency-settings",
  storagesettings: "/storage-settings",
  banipaddress: "/ban-ip-address",
  generalsettings: "/general-settings",
  securitysettings: "/security-settings",
  notification: "/notification",
  connectedapps: "/connected-apps",
  systemsettings: "/system-settings",
  companysettings: "/company-settings",
  localizationsettings: "/localization-settings",
  prefixes: "/prefixes",
  preference: "/preference",
  saleslist: "/sales-list",
  invoicereport: "/invoice-report",
  salesreturn: "/sales-returns",
  quotationlist: "/quotation-list",
  pos: "/pos",
  attendanceadmin: "attendance-admin",
  payslip: "/payslip",
  holidays: "/holidays",
  customers: "/customers",
  suppliers: "/suppliers",
  client: "/client",
  manageclient: "/manageclient",
  service: "/service",
  manageservice: "/manageservice",
  enquiry: "/enquiry",
  manageenquiry: "/manageenquiry",
  manageenquiry1: "/manageenquiry1",
  employees: "/employees",
  manageemployees: "/manageemployees",
  storelist: "/store-list",
  managestock: "/manage-stocks",
  stockadjustment: "/stock-adjustment",
  stocktransfer: "/stock-transfer",
  salesreport: "/sales-report",
  purchasereport: "/purchase-report",
  inventoryreport: "/inventory-report",
  supplierreport: "/supplier-report",
  customerreport: "/customer-report",
  expensereport: "/expense-report",
  incomereport: "/income-report",
  taxreport: "/tax-report",
  profitloss: "/profit-loss-report",
  notes: "/notes",
  filemanager: "/file-manager",
  profile: "/profile",
  signin: "/signin",
  signintwo: "/signin-2",
  signinthree: "/signin", // "/signin-3",
  register: "/register",
  registerTwo: "/register-2",
  registerThree: "/register", // "/register-3",
  forgotPassword: "/forgot-password",
  forgotPasswordTwo: "/forgot-password-2",
  forgotPasswordThree: "/forgot-password-3",
  resetpassword: "/reset-password",
  resetpasswordTwo: "/reset-password-2",
  resetpasswordThree: "/reset-password-3",
  emailverification: "/email-verification",
  emailverificationTwo: "/email-verification-2",
  emailverificationThree: "/email-verification-3",
  twostepverification: "/two-step-verification",
  twostepverificationTwo: "/two-step-verification-2",
  twostepverificationThree: "/two-step-verification-3",
  lockscreen: "/lock-screen",
  error404: "/error-404",
  error500: "/error-500",
  blankpage: "/blank-page",
  comingsoon: "/coming-soon",
  undermaintenance: "/under-maintenance",
  // users: "/users",
  // rolespermission: "/roles-permissions",
  // permissions: "/permissions",
  deleteaccount: "/delete-account",
  employeegrid: "/employees-grid",
  addemployee: "/add-employee",
  editemployee: "/edit-employee",
  leavesadmin: "leaves-admin",
  leavesemployee: "/leaves-employee",
  leavestype: "/leave-types",
  warehouses: "/warehouse",
  coupons: "/coupons",
  payrollList: "/payroll-list",
  Category: "/BusinessCategory",
  AddCategorys: "/AddBusinessCategorys",
  AddCategorysid: "/AddBusinessCategorys/:id",
  BusinessType: "/businessType",
  BusinessTypeid: "/businessType/:id",
  AddBusinessType: "/AddBusinessType",
  AddBusinessTypeID: "/AddBusinessType/:id",
  ServicesType: "/serviceType",
  ServicesTypeid: "/serviceType/:id",
  BusinessTypeList: "/BusinessTypeList",
  ServiceTypeList: "/ServiceTypeList",
  RoleMaster: "/roleMaster",
  RoleMasterList: "/roleMasterList",
  RoleMasterId: "/roleMaster/:id",
  permissionMaster: "/permissionMaster",
  permissionMasterid: "/permissionMaster/:id",
  CurdGenerator: "/dynamicModule",
  CurdGeneratorid: "/dynamicModule/:id",
  BusinessListingMaster: "/businessListingMaster", // not using
  BusinessListingMasterid: "/businessListingMaster/:id", // not using
  BusinessOnboarding: "/businessOnboarding",
  BusinessOnboardList: "/businessOnboardlist",
  BusinessAppoiment: "/BusinessAppoiment",
  BusinessCampaign: "/BusinessCampaign",
  addMultiServices: "/addMultiServices/:id",
  BusinessOnboardingId: "/businessOnboarding/:id",
  PriceType: "/priceType",
  PriceTypeList: "/priceTypeList",
  PriceTypeId: "/priceType/:id",
  StaffListing: "/teamList",
  ServiceList : "/serviceList",
  AddStaff: "/addTeam",
  calendarColorList: "/calendarColorList",
  calendarColor: "/calendarColor",
  calendarColorid: "/calendarColor/:id",
  ManageService: "/manageServices",
  ManageServicebyId: "/manageServices/:ID",
  AddStaffID: "/addTeam/:ID",
  SocialLinkMaster: "/SocialLinkMaster",
  SocialLinkMasterId: "/SocialLinkMaster/:id",
  SocialLinkList: "/SocialLinkList",
  SocialLinkBusinessMaster: "/SocialLinkBusinessMaster",
  SocialLinkBusinessMasterId: "/SocialLinkBusinessMaster/:id",
  SocialLinkBusinessMasterList: "/SocialLinkBusinessMasterList",
  FaqMasterList: "/FaqMasterList",
  FaqMaster: "/FaqMaster",
  FaqMasterId: "/FaqMaster/:id",
  customFieldsMasterList: "/customFieldsMasterList",
  customFieldsMaster: "/customFieldsMaster",
  customFieldsMasterId: "/customFieldsMaster/:id",
  bookingCalendar: "/bookingCalendar",
  bookingCalendarID: "/bookingCalendar/:id",
  blockedTimeTypesList: "/blockedTimeTypesList",
  blockedTimeTypesMaster: "/blockedTimeTypesMaster",
  blockedTimeTypesMasterId: "/blockedTimeTypesMaster/:id",
  businesslistview: "/businesslistview/:id",
  teamlistview: "/teamlistview/:ID",
  ServiceListView: "/servicelistview/:ID",
  customerList: "/customerlist",
  customerImport: "/customer-import",
  customer: "/customer",
  customerId: "/customer/:id",
  zipCodeList: "/zipCodelist",
  zipCode: "/zipCodeMaster",
  zipCodeId: "/zipCodeMaster/:id",
  canceledAppointment: "/canceledappointment",
  BusinessQrPage: "/BusinessQrPage",
  notificationList: "/notificationlist",
  notificationMaster: "/notificationMaster",
  notificationMasterId: "/notificationMaster/:id",
  appConfig: "/appconfig",
  verify: "/verify",
  appointmentList: "/appointmentlist",
  appointmentListID: "/appointmentlist/:id",
  customerSupport: "/customersupport",
  businessRegisterRequest: "/businessregisterrequest",
  businessSubscription: "/businesssubscription",
  businessTransaction: "/businesstransaction",
  businessCustomerTransaction: "/businesscustomertransaction",
};
